import { render } from "./AdminDashboardIndex.vue?vue&type=template&id=76541aaa&scoped=true"
import script from "./AdminDashboardIndex.vue?vue&type=script&lang=js"
export * from "./AdminDashboardIndex.vue?vue&type=script&lang=js"

import "./AdminDashboardIndex.vue?vue&type=style&index=0&id=76541aaa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76541aaa"]])

export default __exports__